import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/app/error.tsx");
